<div (click)="onBackdropClick()" class="modal-backdrop">
  <div (click)="$event.stopPropagation()" class="modal">
    <button mat-flat-button class="close-btn" (click)="onClose()">×</button>
    <h2 i18n>{{ type }}{{ 'addCertificateComponent.add' |translate }}</h2>

    <mat-form-field>
      <mat-label>{{ type }}{{ 'addCertificateComponent.name'| translate }}</mat-label>
      <input matInput [(ngModel)]="newCertificate" type="text"/>
    </mat-form-field>

    <button mat-flat-button class="save-btn" i18n (click)="onSave()">{{ 'general.save' | translate }}</button>
  </div>
</div>
